<template>
    <main class="create-ticket-outer-container-xl">
        <section class="left-side-xl">
            <description />
            <upload-photos />
        </section>
        <section class="right-side-xl">
            <img src="../assets/create-ticket.svg" alt="" width="100%" />
        </section>
    </main>
</template>

<script>
import UploadPhotos from '../components/UploadPhotos.vue';
import Description from '../components/Description.vue';
export default {
    components: { Description, UploadPhotos },
};
</script>

<style lang="scss" scoped>
.create-ticket {
    &-outer-container-xl {
        height: calc(100% - 90px);
        display: grid;
        grid-template-columns: 65% 35%;
    }
}
.left-side-xl {
    height: 100%;
    padding: 8% 0 10%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.right-side-xl {
    height: calc(100% - 80px);
    padding-left: 40px;
    display: flex;
    align-items: flex-end;
}
</style>
